import styles from './PaymentsComparisonLink.module.scss';
import cx from 'classnames';

import React, { HTMLAttributes, useState } from 'react';
import { PaymentsComparisonModal } from './PaymentsComparisonModal/PaymentsComparisonModal';
import { usePaymentsComparisonModalContext } from './PaymentsComparisonModal/PaymentsComparisonModalContext';
import { Button } from 'components/Button/Button';
import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';

interface IPaymentsComparisonLinkProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  textLinkColor?: string;
  textLink?: string;
}

export const PaymentsComparisonLink: React.FC<IPaymentsComparisonLinkProps> = ({
  className,
  textLinkColor = '#000000',
  textLink,
}) => {
  const paymentsComparisonModalType = usePaymentsComparisonModalContext();
  const [isOpen, setIsOpen] = useState(false);

  const paymentComparisonText = textLink ? textLink : paymentsComparisonModalType?.compareLinkText;

  return (
    <>
      <Button
        variant={LinkVariant.TEXT}
        className={cx(className || styles.compareLink)}
        onClick={paymentsComparisonModalType ? () => setIsOpen(true) : undefined}
        style={{ color: textLinkColor }}
      >
        {paymentComparisonText}
      </Button>
      {paymentsComparisonModalType && (
        <PaymentsComparisonModal
          modalState={[isOpen, () => setIsOpen(!isOpen)]}
          entry={paymentsComparisonModalType}
        />
      )}
    </>
  );
};
